<template>
  <v-container style="height: 100%" class="d-flex justify-center align-center">
    <v-window v-model="step">
      <v-window-item :value="1">
        <v-card width="500">
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title>{{
              $store.getters['UserStore/userFullName']
            }}</v-toolbar-title>
          </v-toolbar>
          <v-tabs v-model="tab" dark>
            <v-tab> <v-icon left>account_circle</v-icon>Account </v-tab>
            <v-tab> <v-icon left>lock</v-icon>Password </v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <form>
                    <v-text-field
                      v-model="account.firstName"
                      :error-messages="firstNameErrors"
                      label="First Name"
                      required
                      ref="firstNameInputField"
                      @input="$v.account.firstName.$touch()"
                      @blur="$v.account.firstName.$touch()"
                    ></v-text-field>

                    <v-text-field
                      v-model="account.lastName"
                      :error-messages="lastNameErrors"
                      label="Last Name"
                      required
                      ref="lastNameInputField"
                      @input="$v.account.lastName.$touch()"
                      @blur="$v.account.lastName.$touch()"
                    ></v-text-field>

                    <v-text-field
                      label="Email"
                      value
                      v-model="account.userEmail"
                      readonly
                      ref="userEmailInputField"
                      class="mb-12"
                    ></v-text-field>
                  </form>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-subtitle color="white" class="pb-10">
                  We will send an email with reset link to
                  {{ $store.state.UserStore.user.email }}
                </v-card-subtitle>
              </v-card>
            </v-tab-item>
          </v-tabs>
          <v-card-actions v-if="tab === 0" class="pa-4 d-flex">
            <v-btn color="red" @click="step = 2">CLOSE ACCOUNT</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discardAccount">Discard</v-btn>
            <v-btn
              color="primary"
              @click="submitAccount"
              :disabled="saveButtonDisabled"
              >SAVE</v-btn
            >
          </v-card-actions>
          <v-card-actions v-if="tab === 1" class="pa-4">
            <v-btn color="red" @click="step = 2">CLOSE ACCOUNT</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="sendPasswordResetLink"> Send </v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
      <v-window-item :value="2">
        <v-card dark>
          <v-card-title style="word-break: break-word">
            Are you sure you want to close your account?
          </v-card-title>
          <v-card-text class="pb-0"> Confirm action </v-card-text>
          <v-card-text class="mb-12">
            Your account profile data, along with all your projects and project
            content will be deleated from our records.
          </v-card-text>
          <v-checkbox
            class="ml-3"
            v-model="checkbox"
            :label="
              `If you are a project admin on a project, delete the project.`
            "
          ></v-checkbox>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn @click="step = 1">CANCEL</v-btn>
            <v-btn color="primary" @click="deleteAccount">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
      <v-window-item :value="3">
        <v-card dark>
          <v-card-title class="mb-12" style="word-break: break-word">
            Your account has been successfully closed
          </v-card-title>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="navigateHome">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
      <v-window-item :value="4">
        <v-card dark>
          <v-card-title class="mb-2" style="word-break: break-word">
            We have sent an email with reset link to
            {{ $store.state.UserStore.user.email }}
          </v-card-title>
          <v-card-text class="pb-10">
            Please check your email, we have sent you an email with account
            confirmation link...
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="step = 1">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import ProjectsService from '@/services/ProjectsService'
import MasterplanService from '@/services/MasterplanService'
import PoiService from '@/services/PoiService'
import BuildingService from '@/services/BuildingService'
import ApartmentService from '@/services/ApartmentService'
import ApartmentTypeService from '@/services/ApartmentTypeService'
import MediaService from '@/services/MediaService'
import MediaManagerService from '@/services/MediaManagerService'

export default {
  name: 'Profile',
  mixins: [validationMixin],
  components: {},
  data: () => ({
    account: {
      userEmail: '',
      firstName: '',
      lastName: ''
    },
    checkbox: false,
    tab: 0,
    step: 1,
    changeDetected: false,
    closeAcountDialog: false,
    deletePoiMasterplan: false,
    deletePoiBuilding: false,
    deletePoiApartment: false
  }),
  validations: {
    account: {
      firstName: {
        required
      },
      lastName: {
        required
      }
    },
    validationGroup: ['account']
  },
  methods: {
    deleteMedia: async function(project, method) {
      const getMediaToDelete = await this[method](project.id)
      let mediatoDelete = getMediaToDelete.data
      for (var i = 0; i < mediatoDelete.length; i++) {
        await this.deleteMediaById(mediatoDelete[i].id)
      }
    },
    deletePois: async function(method, projectId) {
      let getPoisToDelete = method.data
      for (var i = 0; i < getPoisToDelete.length; i++) {
        const getMediaForPoi = await this.getMediaForPoi(getPoisToDelete[i].id)
        let mediaPois = getMediaForPoi.data
        await this.deletePoiContent(projectId, getPoisToDelete[i])
        for (var j = 0; j < mediaPois.length; j++) {
          await this.deleteMediaById(mediaPois[j].id)
        }
        await this.deletePoi(getPoisToDelete[i].id)
      }
    },
    deletePoisAndType: async function(buildings, project) {
      for (var i = 0; i < buildings.length; i++) {
        const getApartmentTypesForBuilding = await this.getApartmentTypesForBuilding(
          buildings[i].id
        )
        let apartmentTypeBuilding = getApartmentTypesForBuilding.data
        for (var j = 0; j < apartmentTypeBuilding.length; j++) {
          await this.deleteApartmentType(apartmentTypeBuilding[j].id)
        }
        const getApartmentOrientationsForBuilding = await this.getApartmentOrientationsForBuilding(
          buildings[i].id
        )
        let apartmentOrientationBuilding =
          getApartmentOrientationsForBuilding.data
        for (var k = 0; k < apartmentOrientationBuilding.length; k++) {
          await this.deleteApartmentType(apartmentOrientationBuilding[k].id)
        }
        const getApartmentsForBuilding = await this.getApartmentsForBuilding(
          buildings[i].id
        )
        await this.deletePois(getApartmentsForBuilding, project.id)
      }
    },
    navigateHome: function() {
      this.$router.push('/')
    },
    cancelAccount: function() {
      this.account.firstName = this.$store.state.UserStore.user.firstName
      this.account.lastName = this.$store.state.UserStore.user.lastName
      this.account.userEmail = this.$store.state.UserStore.user.email
    },
    getUsersOnProject: async function(projectId) {
      return await ProjectsService.getUsersOnProject(projectId)
    },
    getProjectSettings: async function(projectId) {
      return await ProjectsService.getProjectSettings(projectId)
    },
    deleteProject: async function(projectId, anonymize) {
      return await ProjectsService.deleteProject(projectId, anonymize)
    },
    getProjectMasterplans: async function(projectId) {
      return await ProjectsService.getProjectMasterplans(projectId)
    },
    getPoisForMasterplan: async function(masterplanId) {
      return await MasterplanService.getPoisForMasterplan(masterplanId)
    },
    deletePoi: async function(poiId) {
      return await PoiService.deletePoi(poiId)
    },
    getBuildingsForMasterplan: async function(masterplanId) {
      return await MasterplanService.getBuildingsForMasterplan(masterplanId)
    },
    getPoisForBuilding: async function(buildingId) {
      return await BuildingService.getPoisForBuilding(buildingId)
    },
    getApartmentsForBuilding: async function(buildingId) {
      return await BuildingService.getApartmentsForBuilding(buildingId)
    },
    getPoisForApartment: async function(apartmentId) {
      return await ApartmentService.getPoisForApartment(apartmentId)
    },
    getApartmentTypesForBuilding: async function(buildingId) {
      return await BuildingService.getApartmentTypesForBuilding(buildingId)
    },
    getApartmentOrientationsForBuilding: async function(buildingId) {
      return await BuildingService.getApartmentOrientationsForBuilding(
        buildingId
      )
    },
    deleteApartmentType: async function(apartmentTypeId) {
      return await ApartmentTypeService.deleteApartmentType(apartmentTypeId)
    },
    getProjectMedia: async function(projectId) {
      return await ProjectsService.getProjectMedia(projectId)
    },
    getMediaForPoi: async function(poiId) {
      return await PoiService.getMediaForPoi(poiId)
    },
    deleteMediaById: async function(mediaId) {
      return await MediaService.deleteMediaById(mediaId)
    },
    deletePoiContent: async function(projectId, data) {
      return await MediaManagerService.deletePoiContent(projectId, data)
    },
    changeAdmin: async function(userId, projectId) {
      let params = {
        newAdminId: userId,
        projectId: parseInt(projectId)
      }
      await this.$store.dispatch('UserStore/changeAdmin', params)
    },
    removeUserFromProject: async function(userId, projectId) {
      let data = {
        userId: userId,
        projectId: projectId
      }
      await this.$store.dispatch('UserStore/removeUserFromProject', data)
    },
    removeAdminFromProject: async function(projectId) {
      const superAdminRole = 1
      this.removeUserFromProject(superAdminRole, projectId)
    },
    removeUsers: async function(users, projectId) {
      for (var i = 0; i < users.length; i++) {
        await this.removeUserFromProject(users[i].id, projectId)
      }
    },
    handleData: async function(project) {
      await this.deleteMedia(project, 'getProjectSettings')
      await this.deleteMedia(project, 'getProjectMedia')

      const getProjectMasterplans = await this.getProjectMasterplans(project.id)
      let masterplans = getProjectMasterplans.data
      for (var i = 0; i < masterplans.length; i++) {
        const getProjectMasterplans = await this.getPoisForMasterplan(
          masterplans[i].id
        )
        await this.deletePois(getProjectMasterplans, project.id)
        const getBuildingsForMasterplan = await this.getBuildingsForMasterplan(
          masterplans[i].id
        )
        await this.deletePois(getBuildingsForMasterplan, project.id)
        await this.deletePoisAndType(getBuildingsForMasterplan.data, project)
      }
      await this.deleteProject(project.id, true)
    },
    deleteAccount: async function() {
      let projects = this.$store.state.ProjectStore.projects
      for (let i = 0; i < projects.length; i++) {
        const users = await this.getUsersOnProject(projects[i].id)
        if (users.data.length > 1) {
          const user = users.data.filter(
            el => el.email === this.account.userEmail
          )
          if (user[0].roleOnProject === 'project_admin') {
            if (this.checkbox) {
              await this.handleData(projects[i])
              await this.removeUsers(users.data, projects[i].id)
              await this.removeAdminFromProject(projects[i].id)
            } else {
              const projectEditorUsers = users.data.filter(
                el =>
                  el.email !== this.account.userEmail &&
                  el.roleOnProject === 'project_editor'
              )
              if (projectEditorUsers.length > 0) {
                await this.changeAdmin(projectEditorUsers[0].id, projects[i].id)
                await this.removeUserFromProject(user[0].id, projects[i].id)
              } else {
                await this.handleData(projects[i])
                await this.removeUsers(users.data, projects[i].id)
                await this.removeAdminFromProject(projects[i].id)
              }
            }
          } else {
            await this.removeUserFromProject(user[0].id, projects[i].id)
          }
        } else {
          await this.handleData(projects[i])
          await this.removeUserFromProject(users.data[0].id, projects[i].id)
          await this.removeAdminFromProject(projects[i].id)
        }
      }
      await this.$store.dispatch(
        'UserStore/deleteUser',
        this.$store.state.UserStore.user.id
      )
      this.$store.dispatch('UserStore/logoutNoRedirect')
      this.step = 3
    },
    submitAccount: function() {
      this.$v.account.$touch()
      if (!this.$v.account.$invalid) {
        this.$store
          .dispatch('UserStore/updateUserData', {
            firstName: this.account.firstName,
            lastName: this.account.lastName
          })
          .then(() => {
            this.cancelAccount()
            this.changeDetected = false
          })
      }
    },
    sendPasswordResetLink: function() {
      this.$store
        .dispatch(
          'AuthStore/sendLoginResetLink',
          this.$store.state.UserStore.user.email
        )
        .then(() => {
          if (
            this.$store.state.AuthStore.loginResetProcessStatus !==
            'email-not-sent'
          ) {
            this.step = 4
          }
        })
    },
    discardAccount() {
      this.account.firstName = this.$store.state.UserStore.user.firstName
      this.account.lastName = this.$store.state.UserStore.user.lastName
      this.changeDetected = false
    },
    focusField: function() {
      setTimeout(() => {
        this.$nextTick(this.$refs.firstNameInputField.focus)
      }, 500)
    }
  },
  computed: {
    saveButtonDisabled: function() {
      return !this.changeDetected
    },
    firstNameErrors: function() {
      const errors = []
      if (!this.$v.account.firstName.$dirty) return errors
      !this.$v.account.firstName.required &&
        errors.push('First name is required')
      return errors
    },
    lastNameErrors: function() {
      const errors = []
      if (!this.$v.account.lastName.$dirty) return errors
      !this.$v.account.lastName.required && errors.push('Last name is required')
      return errors
    }
  },
  mounted: function() {
    this.account.firstName = this.$store.state.UserStore.user.firstName
    this.account.lastName = this.$store.state.UserStore.user.lastName
    this.account.userEmail = this.$store.state.UserStore.user.email
    this.focusField()
  },
  watch: {
    account: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (
          this.account.firstName !==
            this.$store.state.UserStore.user.firstName ||
          this.account.lastName !== this.$store.state.UserStore.user.lastName
        ) {
          this.changeDetected = true
        } else {
          this.changeDetected = false
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.changeDetected) {
      this.$store.dispatch('DialogStore/open', {
        title: 'You did not save the data!',
        text: 'All changes will be lost!',
        okText: 'Stay',
        ok: () => {
          next(false)
        },
        cancelText: 'Discard and leave',
        cancel: () => {
          next()
        }
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped></style>
